<template>
  <div v-if="uiStore.getIsWelcomeScreen()" class="full-video">
    <div class="image-container bg-black">
      <div class="fixed top-4 right-4 z-10">
        <vIcon name="welcomeClose" class="w-6 h-6" @click="handleCloseVideo" />
      </div>
      <video
        class="hero-loop-welcome w-full h-full"
        autoplay
        playsinline
        loop
        preload="metadata"
        :poster="slides[0].image"
        :muted="isVideoMuted"
        @play="handleUnpauseVideo"
        @pause="handlePauseVideo"
        @mute="handleMuteVideo"
        @restart="handleRestartVideo">
        <source :src="slides[0].video" type="video/webm" />
      </video>
      <div class="fixed w-auto bottom-[40px] left-4 right-4 flex items-center justify-between">
        <vIcon name="welcomeRestart" class="w-6 h-6" @click="handleRestartVideo" />
        <div class="flex items-center gap-4">
          <vIcon
            v-if="isVideoPaused"
            name="welcomeUnpause"
            class="w-6 h-6"
            @click="handleUnpauseVideo" />
          <vIcon v-else name="welcomePause" class="w-6 h-6" @click="handlePauseVideo" />
          <vIcon
            v-if="!isVideoMuted"
            name="welcomeUnmute"
            class="w-6 h-6"
            @click="handleMuteVideo" />
          <vIcon v-else name="welcomeMute" class="w-6 h-6" @click="handleUnmuteVideo" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useUiStore } from "@/stores/ui";
import vIcon from "@/components/ui/icon.vue";
import { ref } from "vue";

const uiStore = useUiStore();
const language = uiStore.language;

const emit = defineEmits(["close"]);

const isVideoPaused = ref(false);
const isVideoMuted = ref(true);

const slides = [
  {
    title: "other|onboarding|p2p",
    subtitle: "other|onboarding|p2pDescription",
    // image: "/images/onboarding/1.png",
    video: `/images/onboarding/welcome_${language}_full.webm`,
  },
];

const handlePauseVideo = () => {
  const videoEl = document.querySelector(".hero-loop-welcome");
  if (videoEl && typeof videoEl.pause === "function") {
    videoEl.pause();
  }
  isVideoPaused.value = true;
};

const handleUnpauseVideo = () => {
  const videoEl = document.querySelector(".hero-loop-welcome");
  if (videoEl && typeof videoEl.play === "function") {
    videoEl.play().catch(() => {});
  }
  isVideoPaused.value = false;
};

const handleMuteVideo = () => {
  const videoEl = document.querySelector(".hero-loop-welcome");
  if (videoEl) {
    videoEl.muted = true;
  }
  isVideoMuted.value = true;
};

const handleUnmuteVideo = () => {
  const videoEl = document.querySelector(".hero-loop-welcome");
  if (videoEl) {
    videoEl.muted = false;
  }
  isVideoMuted.value = false;
};

const handleRestartVideo = () => {
  const videoEl = document.querySelector(".hero-loop-welcome");
  if (videoEl) {
    videoEl.currentTime = 0;
    if (typeof videoEl.play === "function") {
      videoEl.play().catch(() => {});
    }
  }
  isVideoPaused.value = false;
};

const handleCloseVideo = () => {
  emit("close");
};
</script>

<style lang="scss" scoped>
.full-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100dvw;
  height: 100dvh;
  overflow: auto;
  z-index: 1000;
  background-color: #111111;
}

.image-container {
  width: 100dvw;
  height: 100dvh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  cursor: pointer;
}

.hero-loop-welcome {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top center;
}
</style>
